import { createSlice } from '@reduxjs/toolkit';
import { articleCodeMP } from "../api/api";

const initialState = {
    response: [],
    codeMP: '',
    loading: false
};

const articleCodeMPSlice = createSlice({
    name: 'articleCodeMP',
    initialState,
    reducers: {
        setCodeMP: (state, action) => {
            state.codeMP = action.payload;
        },
        getArticle: (state, action) => {
            state.codeMP = "";
            state.response = action.payload;
            state.loading = false;
        },
        setLoadingPage: (state) => {
            state.loading = true;
        }
    }
});

export const { setCodeMP, getArticle, setLoadingPage } = articleCodeMPSlice.actions;

// Асинхронные actions
export const fetchArticleCodeMP = (codeMP) => async (dispatch) => {
    try {
        dispatch(setLoadingPage());
        const data = await articleCodeMP.getArticle(codeMP);
        dispatch(getArticle(data));
    } catch (err) {
        console.error(err);
    }
};

export default articleCodeMPSlice.reducer;